import React from 'react';
import type { ModuleOrderProps, Module } from './ModuleOrder.types';
import './ModuleOrder.css';

const ModuleOrder: React.FC<ModuleOrderProps> = ({ onModuleClick, modules: modulesFromApi }) => {
  const modules: Module[] = modulesFromApi ?? [];

  return (
    <div className="module-order-container">
      {modules.length === 0 ? (
        <div className="text-muted p-3">No modules configured.</div>
      ) : (
        modules.map((module) => (
          <div key={module.id} className="module-order-item" onClick={() => onModuleClick(module)}>
            <div className="d-flex align-items-center w-100">
              <span className="module-order-name f-14">{module.name}</span>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default ModuleOrder;
